exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".roaring-companies {\n  border: 0;\n  margin: auto;\n  text-align: center;\n}\n\n.roaring-companies ul {\n  border: 1px solid #E6E6E6;\n  list-style: none;\n  margin: 1rem 0;\n  padding: 0;\n}\n\n.roaring-companies ul li {\n  cursor: pointer;\n}\n\n.roaring-companies .roaring-companies-instruction {\n  color: #0d3a52;\n  font-size: 3.6rem;\n  text-align: center;\n}\n\n", ""]);

// exports
